import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { WindowLocation } from '@reach/router';
import { useIntl } from 'react-intl';
import ContextConsumer from './CompareToolBarContext';
import {
  ToolBar,
  Container,
  Phone,
  Content,
  Remove,
  CloseIcon,
  MobileView,
  CompareContainer,
  RemoveAllPhonesButton,
  CompareButton,
} from './styles';

interface Props {
  location: WindowLocation<unknown>;
}

const CompareToolBar = ({ location }: Props) => {
  const { locale } = useIntl();
  return (
    <ContextConsumer>
      {({ selectedPhones, removePhone, removeAllPhones }) => {
        const [phone1, phone2, phone3] = selectedPhones;
        const LANG_ADDANOTHERDEVICE = locale === 'en' ? 'Add another device' : 'Rajouter un appareil';
        const isOnPhoneComparsionPage = location.pathname.includes('compare-phones');
        // Hide the compareToolBar when on the comparasionPage or we have no phones being compared
        const isHidden = isOnPhoneComparsionPage
            || (!selectedPhones.length && !isOnPhoneComparsionPage);
  
        const LANG_CLEARALL = locale === 'en' ? 'Clear All' : 'Tout Effacer';
        const LANG_COMPARE = locale === 'en' ? 'Compare' : 'Comparer';
        const LANG_DEVICESELECTED = locale === 'en' ? 'Device Selected' : 'Appareil Sélectionné';
        const LANG_DEVICESSELECTED = locale === 'en' ? 'Devices Selected' : 'Appareil Sélectionnés';
  
        if (isHidden) return null;
  
        return (
          <ToolBar data-testid="tool-bar">
            <Container>
              <Phone data-testid="first-phone">
                {phone1 ? (
                  <Content>{phone1.displayName}</Content>
                ) : (
                  <Content defaultMsg>
                    {ReactHtmlParser(LANG_ADDANOTHERDEVICE)}
                  </Content>
                )}
                {phone1 ? (
                  <Remove onClick={() => phone1 && removePhone(phone1)}>
                    <CloseIcon>
                      <span className="bm-cross-left" />
                      <span className="bm-cross-right" />
                    </CloseIcon>
                  </Remove>
                ) : null}
              </Phone>
              <Phone data-testid="second-phone">
                {phone2 ? (
                  <Content>{phone2.displayName}</Content>
                ) : (
                  <Content defaultMsg>
                    {ReactHtmlParser(LANG_ADDANOTHERDEVICE)}
                  </Content>
                )}
                {phone2 ? (
                  <Remove data-testid="phone-2-remove" onClick={() => phone2 && removePhone(phone2)}>
                    <CloseIcon>
                      <span className="bm-cross-left" />
                      <span className="bm-cross-right" />
                    </CloseIcon>
                  </Remove>
                ) : null}
              </Phone>
              <Phone data-testid="third-phone">
                {phone3 ? (
                  <Content>{phone3.displayName}</Content>
                ) : (
                  <Content defaultMsg>
                    {ReactHtmlParser(LANG_ADDANOTHERDEVICE)}
                  </Content>
                )}
                {phone3 ? (
                  <Remove data-testid="phone-3-remove" onClick={() => phone3 && removePhone(phone3)}>
                    <CloseIcon>
                      <span className="bm-cross-left" />
                      <span className="bm-cross-right" />
                    </CloseIcon>
                  </Remove>
                ) : null}
              </Phone>
              <MobileView>
                <p style={{ margin: '0' }}>
                  <span
                    style={{ color: 'red' }}
                  >
                    {`${selectedPhones.length} `}
                  </span>
                  {`${
                    selectedPhones.length === 1
                      ? ReactHtmlParser(LANG_DEVICESELECTED)
                      : ReactHtmlParser(LANG_DEVICESSELECTED)
                  }`}
                </p>
              </MobileView>
              <CompareContainer>
                <RemoveAllPhonesButton
                  linkColor="black"
                  linkSize="xsmall"
                  onClick={removeAllPhones}
                  data-testid="remove-all-phones"
                >
                  {ReactHtmlParser(LANG_CLEARALL)}
                </RemoveAllPhonesButton>
                <CompareButton
                  buttonColor="red"
                  buttonSize="small"
                  route="internal"
                  url="/phones/compare-phones"
                  data-testid="compare-button"
                >
                  {ReactHtmlParser(LANG_COMPARE)}
                </CompareButton>
              </CompareContainer>
            </Container>
          </ToolBar>
        );
      }}
    </ContextConsumer>
  );
};

export default CompareToolBar;
